$(document).ready(function() {
  // Apri il popup quando si clicca sul link con classe 'open-popup'
  $('.open-popup').on('click', function(event) {
    event.preventDefault();
    $('#shopify-section-newsletter-popup, #popup-overlay').fadeIn();
  });

  // Chiudi il popup quando si clicca sul pulsante di chiusura o sull'overlay
  $('.close-popup, #popup-overlay').on('click', function() {
    $('#shopify-section-newsletter-popup, #popup-overlay').fadeOut();
  });
});
